export default __webpack_public_path__ + "static/media/Banners_promodiciembre_gmm_330x330.066514b0.jpg";